const SUPABASE_URL = (import.meta as any).env?.VITE_SUPABASE_URL || ""
const SUPABASE_ANON_KEY = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || ""

export interface Turma {
  id: string
  nome: string
  status: string
  maxVagas: number
  dataInicio: string | null
  dataFim: string | null
}

export const turmasService = {
  async getAll() {
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY) return []
    try {
      const c = new AbortController()
      const t = setTimeout(() => c.abort(), 10000)
      const r = await fetch(SUPABASE_URL + "/rest/v1/turmas?select=*", { method: "GET", headers: { apikey: SUPABASE_ANON_KEY, Authorization: "Bearer " + SUPABASE_ANON_KEY, Accept: "application/json" }, signal: c.signal })
      clearTimeout(t)
      if (!r.ok) return []
      const d = await r.json()
      return d.map((row: any) => ({ id: row.id, nome: row.nome, status: row.status, maxVagas: row.max_vagas, dataInicio: row.data_inicio || null, dataFim: row.data_fim || null }))
    } catch { return [] }
  },
  async update(id: string, updates: Partial<Turma>) {
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY) return null
    const p: any = {}
    if (updates.nome !== undefined) p.nome = updates.nome
    if (updates.status !== undefined) p.status = updates.status
    if (updates.maxVagas !== undefined) p.max_vagas = updates.maxVagas
    try {
      const c = new AbortController()
      const t = setTimeout(() => c.abort(), 10000)
      const r = await fetch(SUPABASE_URL + "/rest/v1/turmas?id=eq." + id, { method: "PATCH", headers: { "Content-Type": "application/json", apikey: SUPABASE_ANON_KEY, Authorization: "Bearer " + SUPABASE_ANON_KEY, Prefer: "return=minimal" }, body: JSON.stringify(p), signal: c.signal })
      clearTimeout(t)
      if (!r.ok) return null
      return { ...updates, id }
    } catch { return null }
  },
}
